import ApplicationForm from '@/components/forms/ApplicationForm';

export default function WorkshopsHealing() {
  return (
    <ApplicationForm
      applicationType="workshops-healing"
      title="Workshops & Healing"
      description="Share your knowledge and healing gifts with our community. We welcome 
        applications from yoga teachers, meditation guides, sound healers, workshop facilitators, 
        and holistic practitioners."
      showPortfolio={true}
      showExperience={true}
      showRequirements={true}
      showInsurance={true}
      showCertificates={true}
    />
  );
}
